import { render, staticRenderFns } from "./add-parameter-Group.vue?vue&type=template&id=a28e5b6c&scoped=true&"
import script from "./add-parameter-Group.vue?vue&type=script&lang=js&"
export * from "./add-parameter-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28e5b6c",
  null
  
)

export default component.exports